export const updateSearchKeyword = (keyword) => ({
    type: "UPDATE_SEARCH_KEYWORD",
    payload: keyword
});
export const updateSearchType = (type) => ({
    type: "UPDATE_SEARCH_TYPE",
    payload: type
})